<template lang="pug">
  div(
    style="width: 100%;"
  )

    // Topbar Navigation Menu
    el-row(class="nav-container")
      el-col(:span="20" :offset="3")
        ul(class="navigation")
          li(
            :class="[currentPage === 'home'? 'li-selected': '']"
            @click="currentPage='home'")
              span Home 

    // Content
    el-main
      el-row(style="margin: 2%;")
        el-col(
          :span="24" )
        
          // FAQ
          div#quiz-info-view(
            class="content-border"
            v-loading="processing")
            div#content
              p.ql-editor.margin-top-15.padding-right-40(
                v-html="content[currentPage]"
              )
</template>

<script>
import utilMixin from '@/components/mixins/utilMixin'

export default {
  name: 'Home',

  mixins: [utilMixin],

  props: {
    type: {
      type: String,
      default: 'home',
    },
  },

  data() {
    return {
      processing: false,
      content: {
        home: '',
        install: '',
        export: '',
        import: '',
      },
      currentPage: this.type,
    }
  },

  computed: {
    inCanvas() {
      return (this.$store.state.canvasData.userId !== null)
    },
  },

  watch: {
    currentPage() {
      this.fetchContent()
    },
  },

  created() {
    this.fetchContent()
  },
  
  methods: {
    fetchContent() {
      if (!this.content[this.currentPage]) {
        this.processing = true
        this.axios.get(`/api/faqs/${this.currentPage}`)
          .then((result) => {
            this.content[this.currentPage] = result.data.object.description
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.mNotification({error: error, message: `Error fetching ${this.currentPage} content.`})
        })
      }
    },
  },
}
</script>


<style module>
.nav-container {
  background: #37474f;
}

.navigation {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.navigation li {
  float: right;
  min-width: 110px;
  padding: 12px 16px 16px 16px;
  display: block;
  font-size: 0.85em;
  color:#fff;
  text-align: center; 
  text-decoration: none;
}

.navigation li:hover {
  background: #222d35;
}

.navigation .li-selected {
   background: #039be5;
}

</style>
